module.exports = __webpack_public_path__ + "static/media/quebec.cb61facd.png";